<template>
  <div class="d-flex justify-space-between my-1" style="width: 100%;">
    <div style="width: 100%;">
      {{ title }}
    </div>
    <div :class="contentClass" style="width: 100%;">
      {{ contentText }}
    </div>
  </div>
</template>
<script>
import { getCssClass } from '@/helpers/statusStyles'
import { getStatusText } from '@/helpers/statusStyles'
export default {
  name: 'ShootingDetailsContent',

  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String
    },
    contentType: {
      type: String,
      default: 'text',
      validator: value => ['text', 'status', 'date'].includes(value)
    }
  },

  computed: {
    contentClass() {
      return getCssClass(this.content)
    },
    contentText() {
      return getStatusText(this.content)
    }
  }
}
</script>
